import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { solidIcons, brandIcons, lightIcons } from './libraries/font-awesome-imports'

// Disable auto CSS insertion since we're importing it in nuxt.config
config.autoAddCss = false

// Add icons to library immediately
library.add(...solidIcons, ...brandIcons, ...lightIcons)

export default defineNuxtPlugin({
  name: 'font-awesome',
  setup(nuxtApp) {
    // Register FontAwesome component globally
    nuxtApp.vueApp.component('font-awesome', FontAwesomeIcon)
  }
})
